export default "__VITE_ASSET__CRGPkAWJ__"